import { defaultMaterialProperties, type MaterialProperties } from '../hooks/useMaterialProperties';

export type MaterialByFinish = Record<string, MaterialProperties>;

export const materialKeyForFinish = (finishType?: string | null) =>
  finishType && finishType.trim() ? finishType : 'default';

export const materialContextForFinish = (finishType?: string | null) =>
  finishType && finishType.trim() ? `finish:${finishType}` : 'global';

export const resolveMaterialForFinish = (
  materials: MaterialByFinish | undefined,
  finishType?: string | null,
  fallback?: MaterialProperties
): MaterialProperties => {
  const base = fallback ?? defaultMaterialProperties;
  if (!materials) return base;
  const key = materialKeyForFinish(finishType);
  if (materials[key]) return { ...base, ...materials[key] };
  if (materials.default) return { ...base, ...materials.default };
  return base;
};
